import React from 'react'
import { IonPage, IonContent } from '@ionic/react'
import { useHistoryNew, copyText, toast } from '@utils'
import './index.scss'

const NotWeixin: React.FC = (props: any) => {
  const history = useHistoryNew()
  const { state } = props.location
  const copyUrl = () => {
    if (state?.url) {
      copyText(state?.url)
      toast({ message: '复制成功, 去浏览器中打开链接' })
    }
  }
  return (
    <IonPage className='my-invoice-not-page'>
      <IonContent>
        <div className='my-invoice-not'>
          <span className='emoji'>🤔</span>
          <h3>由于微信限制，目前无法在小程序中直接查看电子发票</h3>
          <div className='copy-area'>
            <div className='title'>解决方案: </div>
            <div>去浏览器中打开链接</div>
            <div className='copy' onClick={copyUrl}>
              <i className='iconfont icon-magnify'></i>
              <span>复制链接</span>
            </div>
          </div>
          <div
            className='back-btn' onClick={() => {
              history.goBack()
            }}
          >返回
          </div>
        </div>
      </IonContent>
    </IonPage>
  )
}

export default NotWeixin
